import app from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

class Firebase {

    constructor() {
        app.initializeApp({
            apiKey: "AIzaSyCPl63pVcZ7gSNKd5VIv61Cz4s_zecn5O4",
            authDomain: "fractal-strategies.firebaseapp.com",
            databaseURL: "https://fractal-strategies.firebaseio.com",
            projectId: "fractal-strategies",
            storageBucket: "fractal-strategies.appspot.com",
            messagingSenderId: "478577074690"
        })
        this.auth = app.auth()
        this.firestore = app.firestore()
    }

    getDoc = (collection, doc, cb) => {
        this.firestore.collection(collection).doc(doc).get()
            .then(doc => {
                if (!doc.exists) {
                    console.log('No such document!')
                } else {
                    cb(doc.data())
                }
            })
    }

    setDoc = (collection, doc, setDoc) => {
        this.firestore.collection(collection).doc(doc).set(setDoc)
    }

    getCollection = (ref, cb) => {
        this.firestore.collection(ref).onSnapshot(snapshot => {
            let collection = {}
            snapshot.forEach(doc => {
                collection[doc.id] = doc.data()
            })
            cb(collection)
        })
    }

    createUserWithEmailAndPassword = (email, password) => {
        this.auth.createUserWithEmailAndPassword(email, password)
    }

    signInWithEmailAndPassword = (email, password) => {
        this.auth.signInWithEmailAndPassword(email, password)
    }

    signOut = () => {
        this.auth.signOut()
    }

    resetPassword = email => {
        this.auth.sendPasswordResetEmail(email)
    }

    updatePassword = password => {
        this.auth.currentUser.updatePassword(password)
    }

}

export default Firebase
